import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Marquee } from 'atoms/container/Marquee';
import { useQuery } from 'hooks/graphql/useQuery';

import type {
  SignupLeaguesQuery,
  SignupLeaguesQueryVariables,
} from './__generated__/index.graphql';

const Root = styled.div`
  width: var(--100vw);
  overflow: hidden;
  padding-bottom: var(--quadruple-unit);
`;

const SIGNUP_LEAGUES_QUERY = gql`
  query SignupLeaguesQuery {
    football {
      leaguesOpenForGameStats(sortType: { direction: ASC, type: PRIORITY }) {
        slug
        displayName
        pictureSecondaryUrl
        pictureUrl(derivative: "low_res")
      }
    }
  }
` as TypedDocumentNode<SignupLeaguesQuery, SignupLeaguesQueryVariables>;

export const SignupLeaguesCarousel = () => {
  const { data } = useQuery(SIGNUP_LEAGUES_QUERY, {});

  const filteredLeagues =
    data?.football.leaguesOpenForGameStats.filter(
      league =>
        !!league.pictureUrl &&
        //filter out leagues with ugly (flags) pictures
        !!league.pictureSecondaryUrl
    ) || [];
  return (
    <Root>
      <Marquee gap={3}>
        {filteredLeagues.map(league => (
          <img
            key={league.slug}
            src={league.pictureUrl!}
            height={40}
            alt={league.displayName}
          />
        ))}
      </Marquee>
    </Root>
  );
};
